/**
 * collection-tree-node组件
 * 无感刷新数据逻辑
 */
document.addEventListener('DOMContentLoaded', () => {
  const dataEl = document.getElementById('CollectionTreeData');
  const pcContainer = document.getElementById('CollectionTreeContainer');
  const mobileContainer = document.getElementById('CollectionTreeContainerMobile');
  
  if (!dataEl || (!pcContainer && !mobileContainer)) return;

  // 原始解析出来的全量分类
  let rawCollections = JSON.parse(dataEl.textContent);

  // ==========================================
  // 【黑名单过滤逻辑】
  // 在生成树状结构前，直接把不需要显示的 handle 剔除掉
  // ==========================================
  const hiddenHandles = ['all-product']; 
  const collections = rawCollections.filter(col => !hiddenHandles.includes(col.handle));

  // 1. 扁平组装树结构
  const buildTree = (list) => { 
    const map = {}, roots = [];
    list.forEach(item => { item.children = []; map[item.handle] = item; });
    list.forEach(item => {
      if (item.parent && map[item.parent]) {
        map[item.parent].children.push(item);
      } else {
        roots.push(item);
      }
    });
    return roots;
  };

  // 2. 智能剪枝(无产品的collection不显示逻辑)
  const pruneEmptyBranches = (nodes) => { 
    return nodes.filter(node => {
      node.children = pruneEmptyBranches(node.children);
      return node.productCount > 0 || node.children.length > 0;
    });
  };

  // 3. 递归生成 HTML
  const renderTreeHTML = (nodes, isFirstLevel = true) => {
    if (!nodes || nodes.length === 0) return '';
    let html = `<ul class="category-tree-list ${isFirstLevel ? 'is-root' : ''}">`;
    nodes.forEach(node => {
      const hasChildren = node.children && node.children.length > 0;
      html += `
        <li class="category-tree-item" data-handle="${node.handle}">
          <div class="category-tree-row">
            ${hasChildren ? `
              <button class="category-tree-toggle" type="button" aria-label="Toggle Submenu">
                <svg viewBox="0 0 10 6" fill="none" stroke="currentColor"><path d="M1 1l4 4 4-4" stroke-width="1.5"/></svg>
              </button>
            ` : '<span class="category-tree-spacer"></span>'}
            <a href="${node.url}" class="category-tree-link">
              <span class="title-text">${node.title}</span>
              <span class="count-badge">(${node.productCount})</span>
            </a>
          </div>
          ${hasChildren ? renderTreeHTML(node.children, false) : ''}
        </li>
      `;
    });
    html += '</ul>';
    return html;
  };

  let treeStructure = buildTree(collections);
  treeStructure = pruneEmptyBranches(treeStructure);

  // ==========================================
  // 递归自定义排序逻辑 (通过 Metafield 权重)
  // 不管树状结构嵌套多少层，一次性全部按设定好的 SortOrder 排序
  // ==========================================
  const sortTreeRecursively = (nodes) => {
    // 1. 对当前层级进行排序 (数字小的在前，没填默认 999 在后)
    nodes.sort((a, b) => {
      const orderA = (a.sortOrder !== undefined && a.sortOrder !== null) ? a.sortOrder : 999;
      const orderB = (b.sortOrder !== undefined && b.sortOrder !== null) ? b.sortOrder : 999;
      return orderA - orderB;
    });

    // 2. 遍历当前层级，如果谁有子节点，就递归进去继续排
    nodes.forEach(node => {
      if (node.children && node.children.length > 0) {
        sortTreeRecursively(node.children);
      }
    });

    return nodes;
  };

  // 执行全树排序
  treeStructure = sortTreeRecursively(treeStructure);

  // 渲染并输出两端
  const finalHTML = renderTreeHTML(treeStructure);
  if (pcContainer) pcContainer.innerHTML = finalHTML;
  if (mobileContainer) mobileContainer.innerHTML = finalHTML;

  // 4. 高亮当前激活节点并展开父级
  const currentHandle = window.location.pathname.split('/').pop();
  document.querySelectorAll(`.category-tree-item[data-handle="${currentHandle}"]`).forEach(item => {
    item.classList.add('is-active');
    let parent = item.parentElement.closest('.category-tree-item');
    while (parent) {
      parent.classList.add('is-open');
      parent = parent.parentElement.closest('.category-tree-item');
    }
  });

  // 全局共享一个 AbortController，确保多终端(PC/Mobile)点击共享同一个中断逻辑
  let currentAbortController = null;

  const setupTreeEvents = (container) => {
    if (!container) return;

    container.addEventListener('click', async (e) => {
      const toggleBtn = e.target.closest('.category-tree-toggle');
      const link = e.target.closest('.category-tree-link');

      // 场景 A：点击小箭头 -> 纯粹的 UI 展开/折叠
      if (toggleBtn) {
        e.preventDefault();
        e.stopPropagation();
        toggleBtn.closest('.category-tree-item').classList.toggle('is-open');
        return;
      }

      // 场景 B：点击分类文字 -> 仅请求数据，不控制折叠/展开
      if (link) {
        e.preventDefault();
        const item = link.closest('.category-tree-item');
        const handle = item.dataset.handle;

        // 获取包含当前语言前缀的真实 URL
        const targetUrl = link.getAttribute('href');

        const productGridContainer = document.getElementById('ProductGridContainer');

        if (!productGridContainer) return;

        // 如果点击的是当前已激活菜单，直接忽略
        if (item.classList.contains('is-active')) return;

        // 1. 立即响应 UI：切换双端的高亮状态
        document.querySelectorAll('.category-tree-item').forEach(el => el.classList.remove('is-active'));
        document.querySelectorAll(`.category-tree-item[data-handle="${handle}"]`).forEach(el => {
          el.classList.add('is-active');
        });

        // 2. 立即开启 Loading 状态 (依赖 CSS 控制显示)
        // 给商品网格和商品数量统计加上 loading 类名
        const collectionNode = productGridContainer.querySelector('.collection');
        if (collectionNode) collectionNode.classList.add('loading');
        
        const countContainer = document.getElementById('ProductCount');
        if (countContainer) countContainer.classList.add('loading');

        const countContainerDesktop = document.getElementById('ProductCountDesktop');
        if (countContainerDesktop) countContainerDesktop.classList.add('loading');

        // (可选) 平滑滚动到顶部，增强换页感
        // window.scrollTo({ top: 0, behavior: 'smooth' });

        // 3. 网络请求管理：中断上一次未完成的请求
        if (currentAbortController) currentAbortController.abort();
        currentAbortController = new AbortController();
        const signal = currentAbortController.signal;

        try {
          // 直接请求整个 Collection 页面
          // const response = await fetch(`/collections/${handle}`, { signal });
          const response = await fetch(targetUrl, { signal });

          if (!response.ok) {
            if (response.status === 429) throw new Error('TOO_MANY_REQUESTS');
            throw new Error(`HTTP_ERROR_${response.status}`);
          }

          const htmlText = await response.text();
          const htmlDoc = new DOMParser().parseFromString(htmlText, 'text/html');
          
          // 1. 替换商品列表
          const newGrid = htmlDoc.getElementById('ProductGridContainer');
          if (newGrid) productGridContainer.innerHTML = newGrid.innerHTML;
          
          // Banner 替换逻辑
          const oldBannerSection = document.querySelector('[id*="custom_image_banner_heading"]'); 
          const newBannerSection = htmlDoc.querySelector('[id*="custom_image_banner_heading"]');
          
          if (oldBannerSection && newBannerSection) {
             oldBannerSection.innerHTML = newBannerSection.innerHTML;
             
             // 如果 banner 的背景图或者某些动画需要 JS 重新初始化，如果存在的话可以在这里触发
             // 例如有些幻灯片插件： if(window.Flickity) ...
          }

          // 同步网页标题
          document.title = htmlDoc.title;

          // 更新浏览器历史记录
          // history.pushState({ handle: handle }, '', `/collections/${handle}`);
          history.pushState({ handle: handle }, '', targetUrl);

          const mobileWrapper = link.closest('.mobile-facets__wrapper');
          if (mobileWrapper) {
            const detailsTag = mobileWrapper.querySelector('details');
            if (detailsTag) detailsTag.removeAttribute('open');
          }

        } catch (error) {
          if (error.name === 'AbortError') return;
          console.error('Collection fetch error:', error);
          if (error.message === 'TOO_MANY_REQUESTS') {
            console.log('您操作得太快了，请稍等片刻再试。'); 
          } else {
            console.log('加载失败，请检查网络或刷新页面重试。');
          }
          
          document.querySelectorAll('.category-tree-item').forEach(el => el.classList.remove('is-active'));
          const fallbackHandle = window.location.pathname.split('/').pop();
          document.querySelectorAll(`.category-tree-item[data-handle="${fallbackHandle}"]`).forEach(el => el.classList.add('is-active'));

        } finally {
          if (!signal.aborted) {
            const currentCollection = productGridContainer.querySelector('.collection');
            if (currentCollection) currentCollection.classList.remove('loading');
            
            const currentCount = document.getElementById('ProductCount');
            if (currentCount) currentCount.classList.remove('loading');
            
            const currentCountDesktop = document.getElementById('ProductCountDesktop');
            if (currentCountDesktop) currentCountDesktop.classList.remove('loading');
          }
        }
      }
    });
  };

  setupTreeEvents(pcContainer);
  setupTreeEvents(mobileContainer);

  // ========== 预防深水区：监听浏览器前进/后退 ==========
  // 当用户使用浏览器的返回按钮时，URL 改变了，但因为是无刷新，页面内容并不会变。
  // 最稳妥、最不产生 Bug 的方案是监听此事件并直接重新加载页面。
  window.addEventListener('popstate', (event) => {
    // 检测是否是我们 pushState 推入的历史记录
    if (event.state && event.state.handle) {
      // 直接 reload 保证数据、筛选器(facets)、URL 完全一致同步
      window.location.reload(); 
    }
  });

});

/**
 * 搜索框交互规则（核心：仅展开/收缩两种状态）：
 * 1. 基础：展开/收缩UI交互；
 * 2. search-icon-text：展开→隐藏text、icon左移（始终显示）；收缩→text+icon都显示；
 * 3. clear-btn：仅「展开+有内容」显示，其余情况（展开无内容/收缩）均隐藏；
 * 4. expand-search-overlay：展开显示，收缩隐藏；
 */
document.addEventListener("DOMContentLoaded", function () {
  // 1. 基础元素获取
  const predictiveSearchEl = document.querySelector(
    "predictive-search.predictive-search-custom",
  );
  if (!predictiveSearchEl) return;

  const expandSearch = document.querySelector(".expand-search");
  const expandSearchInput = expandSearch?.querySelector('input[name="q"]');
  const clearBtn = document.querySelector(".clear-btn");
  const searchIconText = document.querySelector(".search-icon-text");
  const textElement = searchIconText?.querySelector(".text");
  const searchOverlay = document.querySelector(".expand-search-overlay");

  // 安全校验：所有核心元素存在才执行
  if (
    !expandSearchInput ||
    !searchIconText ||
    !searchOverlay ||
    !expandSearch ||
    !clearBtn
  )
    return;

  // 2. 核心状态管理函数
  /**
   * 更新搜索框所有交互状态
   * @param {boolean} isExpanded - 是否展开（true=展开，false=收缩）
   */
  function updateSearchUI(isExpanded) {
    const hasContent = expandSearchInput.value.trim() !== "";

    // ===== 规则1/3：展开/收缩 基础UI =====
    expandSearch.style.width = isExpanded ? "900px" : "100px";
    expandSearchInput.style.width = "100%";
    // 收缩时隐藏输入内容（视觉上），展开时显示
    expandSearchInput.classList.toggle("input-content-hidden", !isExpanded);

    // ===== 规则4/5：search-icon-text 交互 =====
    // 展开：text隐藏，icon显示且左移；收缩：text+icon都显示
    textElement.style.opacity = isExpanded ? "0" : "1";
    expandSearchInput.style.setProperty(
      "--placeholder-opacity",
      isExpanded ? "1" : "0",
    );

    // ===== 规则6/7/8/9：clear-btn 交互 =====
    // 仅 展开+有内容 显示清空按钮，其余情况隐藏
    const showClearBtn = isExpanded && hasContent;
    clearBtn.classList.toggle("show", showClearBtn);
    expandSearchInput.classList.toggle("has-content", hasContent);

    // ===== 规则10/11：expand-search-overlay 交互 =====
    // 展开显示遮罩，收缩隐藏遮罩
    searchOverlay.classList.toggle("show", isExpanded);

    // 调试日志（可删除）
    // const status = isExpanded
    //   ? hasContent
    //     ? "展开+有内容"
    //     : "展开+无内容"
    //   : hasContent
    //     ? "收缩+有内容"
    //     : "收缩+无内容";
    // console.log(`当前状态：${status}`);
  }

  // 3. 事件绑定（仅处理展开/收缩核心逻辑）
  // 3.1 聚焦 = 展开
  expandSearchInput.addEventListener("focus", function (e) {
    updateSearchUI(true);
    // 保留PredictiveSearch原生逻辑
    if (predictiveSearchEl.onFocus) predictiveSearchEl.onFocus(e);
  });

  // 3.2 失焦 = 收缩（延迟避免下拉框点击失效）
  expandSearchInput.addEventListener("blur", function (e) {
    setTimeout(() => {
      if (!predictiveSearchEl.contains(document.activeElement)) {
        updateSearchUI(false);
      }
    }, 100);
  });

  // 3.3 输入内容时更新状态（仅影响clear-btn，不改变展开/收缩）
  expandSearchInput.addEventListener("input", function (e) {
    const isExpanded = expandSearchInput.matches(":focus");
    updateSearchUI(isExpanded);
    // 保留PredictiveSearch原生逻辑
    if (predictiveSearchEl.onChange) predictiveSearchEl.onChange(e);
  });

  // 3.4 清空按钮点击事件
  clearBtn.addEventListener("click", function (e) {
    e.preventDefault();
    expandSearchInput.value = "";
    expandSearchInput.focus(); // 清空后保持展开状态
    updateSearchUI(true);
    // 保留PredictiveSearch原生逻辑
    if (predictiveSearchEl.onFormReset) predictiveSearchEl.onFormReset(e);
  });

  // 3.5 键盘事件（回车/ESC）
  expandSearchInput.addEventListener("keydown", function (e) {
    // 回车：空内容阻止提交，有内容走原生逻辑
    if (e.key === "Enter") {
      const searchValue = this.value.trim();
      if (!searchValue) {
        e.preventDefault();
        console.log("请输入搜索内容");
      } else if (predictiveSearchEl.onFormSubmit) {
        predictiveSearchEl.onFormSubmit(e);
      }
    }
    // 上下键：保留原生预测搜索逻辑
    if (e.code === "ArrowUp" || e.code === "ArrowDown") {
      if (predictiveSearchEl.onKeydown) predictiveSearchEl.onKeydown(e);
    }
  });

  // 3.6 ESC键：收缩输入框
  document.addEventListener("keyup", (e) => {
    if (
      e.code.toUpperCase() === "ESCAPE" &&
      expandSearchInput.matches(":focus")
    ) {
      expandSearchInput.blur();
      updateSearchUI(false);
    }
  });

  // 3.7 监听【浏览器窗口失去焦点】→ 处理【点击浏览器外部】
  // 无内容时，点击桌面/其他软件 → 强制失焦收缩搜索框
  window.addEventListener('blur', () => {
    const isFocused = document.activeElement === expandSearchInput;
    const isEmpty = expandSearchInput.value.trim() === '';
    if (isFocused && isEmpty) {
      expandSearchInput.blur();
      updateSearchUI(false);
    }
  });

  // 4. 初始化状态（页面加载时为收缩状态）
  updateSearchUI(false);
});

/**
 * card-with-bg组件
 * featured-common-cards组件
 * 普通卡片的文字上移交互效果
 */
document.addEventListener('DOMContentLoaded', function () {
  const initCardAnimation = () => {
    if (window.innerWidth <= 749) return;

    const commonCards = document.querySelectorAll('.card-wrapper.common-card');
    if (!commonCards) return;

    commonCards.forEach(cardEl => {
      // 关键：先清除旧事件，防止多次绑定
      cardEl.removeEventListener('mouseenter', handleCardEnter);
      cardEl.removeEventListener('mouseleave', handleCardLeave);
      
      // 绑定移入、移出
      cardEl.addEventListener('mouseenter', handleCardEnter);
      cardEl.addEventListener('mouseleave', handleCardLeave);
    });
  };
  
  // 鼠标移入：展开
  function handleCardEnter(e) {
    const currentCard = e.currentTarget; // 真正当前触发的卡片
    const desc = currentCard.querySelector('.card-des');
    if (!desc) return;

    desc.style.webkitLineClamp = 'unset';
    desc.style.overflow = 'visible';
    desc.style.display = 'block';

    desc.style.height = 'auto';
    const h = desc.offsetHeight;
    desc.style.height = 'calc(16px * 1.5 * 2)';

    desc.clientHeight; // 强制重绘

    desc.style.transition = '0.8s cubic-bezier(.22,1,.36,1)';
    desc.style.height = h + 'px';

    // 只打印当前卡片的 desc 高度
    // desc.style.height = 'auto';
    // const h = desc.offsetHeight;
    // desc.style.height = 'calc(16px * 1.5 * 2)';

    // // 强制渲染
    // desc.clientHeight; // 读取任何几何信息,均能出发强制渲染(layout reflow)

    // desc.style.transition = '0.8s cubic-bezier(.22,1,.36,1)';
    // desc.style.height = h + 'px';
  }

  // 鼠标移出：收起
  function handleCardLeave(e) {
    const currentCard = e.currentTarget;
    const desc = currentCard.querySelector('.card-des');
    if (!desc) return;

    desc.style.transition = '0.8s cubic-bezier(.22,1,.36,1)';
    desc.style.height = 'calc(16px * 1.5 * 2)';

    // 动画结束后恢复省略号样式
    setTimeout(() => {
      desc.style.webkitLineClamp = '2';
      desc.style.overflow = 'hidden';
      desc.style.display = '-webkit-box';
      desc.style.webkitBoxOrient = 'vertical';
    }, 100); // 与动画时间一致

    // 平滑收回默认两行高度
    // desc.style.transition = '0.8s cubic-bezier(.22,1,.36,1)';
    // desc.style.height = 'calc(16px * 1.5 * 2)';
  }

  // 初始化
  initCardAnimation();

  // 监听窗口大小变化（适配横竖屏切换）
  window.addEventListener('resize', initCardAnimation);
});
